import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-7xl mx-auto p-6 my-10 shadow-lg border bg-white rounded-lg">
      <h1 className="text-3xl font-bold text-center">Terms & Conditions</h1>
      <p className="text-center font-xs text-gray-600 pb-4 mb-3 border-b-2">
        Last updated 08 Aug 2024
      </p>
      <p className="mb-4">
        Welcome to <strong>Brain Box Study!</strong> Before using our website (www.brainboxstudy.com), please read our terms and conditions carefully. By accessing or using our website, you agree to follow these rules.
      </p>

      <h2 className="text-xl font-semibold mb-2">1. Use of Our Website</h2>
      <ul className="list-disc list-inside mb-4">
        <li>The content on our website is for <strong>learning purposes only</strong> . Do not copy or misuse it.</li>
        <li>Do not use our website for illegal activities or to harm others.</li>
      </ul>

      <h2 className="text-xl font-semibold mb-2">2. Account & Security</h2>
      <ul className="list-disc list-inside mb-4">
        <li>When you create an account, you must provide <strong>accurate</strong>  details.</li>
        <li>Keep your <strong>login details private</strong> . We are not responsible for any misuse of your account.</li>
        <li>If you notice any unusual activity, contact us immediately.</li>
      </ul>

      <h2 className="text-xl font-semibold mb-2">3. Course Enrollment & Payments</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Once you enroll in a course, <strong>you get access to the content</strong> as per the course plan.</li>
        <li>All payments made are <strong>non-refundable </strong> unless stated otherwise.</li>
        <li>You cannot <strong>share or resell</strong> course materials.</li>
      </ul>

      <h2 className="text-xl font-semibold mb-2">4. Intellectual Property</h2>
      <ul className="list-disc list-inside mb-4">
        <li>All content, including <strong>videos, PDFs, and graphics,</strong> belongs to <strong>Brain Box Study</strong>.</li>
        <li>You are not allowed to copy, share, or modify our content <strong>without permission</strong>.</li>
      </ul>

      <h2 className="text-xl font-semibold mb-2">5. Limitation of Liability</h2>
      <ul className="list-disc list-inside mb-4">
        <li>We do our best to provide <strong>accurate and up-to-date</strong> content. However, we are not responsible for any <strong>errors or technical issues</strong>.</li>
        <li>We are not responsible for any <strong>losses or damages</strong> caused by using our website.</li>
      </ul>

      <h2 className="text-xl font-semibold mb-2">6. Changes to Terms</h2>
      <p className="mb-4">
        We may update these terms from time to time. If we make big changes, we will <strong>notify users</strong> on our website.
      </p>

      <h2 className="text-xl font-semibold mb-2">7. Contact Us</h2>
      <p className="mb-4">If you have any questions about our Terms & Conditions, reach out to us:</p>
      <p className="mb-4 font-semibold">info@brainboxstudy.com</p>
    </div>
  );
};

export default TermsAndConditions;